import * as turf from './turf';
import classNames from 'classnames';
import './overlay.scss';

const Overlay = ({polygons, map, maps, ignoreArea = false, center = null, modifiers}) => {
    class AreaOverlay extends maps.OverlayView {
        constructor() {
            super();
            this.pane = null;
            this.maps = maps;
            this.labelOverlay = document.createElement('div');
            this.labelOverlay.className = 'overlay-container';
        }

        onAdd() {
            if (!polygons) return;
            
            const map = this.getMap();
            if (!map) return;

            this.center = map.getCenter();
            this.pane = this.getPanes();
            this.pane.overlayMouseTarget.appendChild(this.labelOverlay);
            
            const fragment = document.createDocumentFragment();

            polygons.forEach(featureData => {
                let label = null;
                if (featureData.feature.geometry.type === 'GeometryCollection') {
                    let labelPos = null;
                    if (featureData.feature.properties.homeMarkerGeoJson) {
                        labelPos = featureData.feature.properties.homeMarkerGeoJson[0];
                        
                        featureData.feature.geometry.geometries.forEach(polygon => {
                            label = this.renderLabel(featureData.feature, labelPos, ignoreArea, modifiers);
                        });

                        if (label) {
                            fragment.appendChild(label);
                        }

                    } else {
                        featureData.feature.geometry.geometries.forEach(polygon => {
                            labelPos = turf.pointOnFeature(polygon);
                            const area = turf.area(polygon);
                            label = this.renderLabel(featureData.feature, labelPos, ignoreArea, modifiers, area);

                            if (label) {
                                fragment.appendChild(label);
                            }
                        });
                    }
                } else {
                    let labelPos = null;
                    if (featureData.feature.properties.homeMarkerGeoJson) {
                        labelPos = featureData.feature.properties.homeMarkerGeoJson[0];
                        label = this.renderLabel(featureData.feature, labelPos, ignoreArea, modifiers);
                        
                        if (label) {
                            fragment.appendChild(label);
                        }

                    } else {
                        labelPos = turf.pointOnFeature(featureData.polygon);
                        const area = turf.area(featureData.polygon);
                        label = this.renderLabel(featureData.feature, labelPos, ignoreArea, modifiers, area);
                        
                        if (label) {
                            fragment.appendChild(label);
                        }
                    }
                }
            });
            
            this.labelOverlay.append(fragment);
        }

        renderLabel(feature, labelPos, ignoreArea, modifiers, area) {            
            const map = this.getMap();
            if (!map) return null;

            const zoom = map.getZoom();
            if (area && zoom < 4 && area  < 50000000000) return null;
            if (area && zoom < 5 && area < 10000000000) return null;
            if (area && zoom < 7 && area < 1000000000) return null;
            if (area && zoom < 8 && area < 200000000) return null;
            if (area && zoom < 9 && area < 100000000) return null;
            if (area && zoom < 10 && area < 100000000) return null;
            if (area && zoom < 11 && area < 10000000) return null;
            if (area && zoom < 12 && area < 5000000) return null;
            if (!ignoreArea && area && zoom < 13 && area < 1000000) return null;
            if (!ignoreArea && area && zoom < 14 && area < 500000) return null;
            if (!ignoreArea && area && zoom < 15 && area < 100000) return null;
            if (!ignoreArea && area && zoom < 16 && area < 50000) return null;
            
            const position = this.toLatLng(labelPos.geometry.coordinates);

            if (!ignoreArea) {
                if (!map.getBounds().contains(position)) return null;    
            }

            const overlayProjection = this.getProjection();
            const nw = overlayProjection.fromLatLngToDivPixel(position);

            const div = document.createElement('div');
            div.style.position = 'absolute';
            div.innerHTML = feature.properties.name;
            div.className = classNames({
                'overlay-label': true,
                ...modifiers
            });
            div.style.left = nw.x + "px";
            div.style.top = nw.y + "px";

            return div;
        }

        draw() {
            const map = this.getMap();
            if (!map) return;
            
            const overlayProjection = this.getProjection();
            const nw = overlayProjection.fromLatLngToDivPixel(this.center);
            this.labelOverlay.style.left = nw.x + 'px';
            this.labelOverlay.style.top = nw.y + 'px';
        }

        onRemove() {
            if (this.labelOverlay) {
                if (this.labelOverlay.parentNode) {
                    this.labelOverlay.parentNode.removeChild(this.labelOverlay);
                }
                this.labelOverlay = null;
            }
        }

        remove() {
            this.setMap(null);
        }

        toLatLng(point) {
            return new this.maps.LatLng(point[1], point[0]);
        }
    }

    const lblOverlay = new AreaOverlay();
    lblOverlay.setMap(map);
    return lblOverlay;
};
export default Overlay;